import { getRegisterFunction } from '../../utils/register.js';
import { OneUxFeedbackElement } from './OneUxFeedbackElement.js';
export const register = getRegisterFunction(OneUxFeedbackElement);
declare global {
  interface HTMLElementTagNameMap {
    'one-ux-feedback': OneUxFeedbackElement;
    "feedback-14d210468f1a15e6799e58a51afcbbb8": OneUxFeedbackElement;
  }
}